var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
import { OfferBadgeBackground, OfferBadgeIcon, } from '@volkswagen-onehub/icons-core';
const StyledOfferBadgeBackground = styled(OfferBadgeBackground).withConfig({ displayName: "StyledOfferBadgeBackground", componentId: "sc-p8z6at" }) `color:${({ theme }) => theme.colors.accent.offer.default};`;
const StyledOfferBadgeIcon = styled(OfferBadgeIcon).withConfig({ displayName: "StyledOfferBadgeIcon", componentId: "sc-1kqpctb" }) `position:absolute;top:0;left:0;color:${({ theme }) => theme.colors.content.invertedOnSurface};`;
const StyledOfferBadge = styled.div.withConfig({ displayName: "StyledOfferBadge", componentId: "sc-1ruyhtn" }) `position:relative;display:inline-flex;margin:0;padding:0;font-weight:initial;line-height:1;`;
export const OfferBadge = React.forwardRef((props, forwardRef) => {
    const { ariaLabel, variant = 'default' } = props, rest = __rest(props, ["ariaLabel", "variant"]);
    const commonProps = getCommonProps(props);
    return (React.createElement(StyledOfferBadge, Object.assign({ ref: forwardRef, "aria-label": ariaLabel, variant: variant }, commonProps, rest),
        React.createElement(StyledOfferBadgeBackground, null),
        React.createElement(StyledOfferBadgeIcon, null)));
});
OfferBadge.displayName = 'OfferBadge';
